import React from 'react';

export default function ({ sideBarData, eleRef }) {
    return (
    <div>
        {eleRef.state.loggedin && eleRef.state.isTryingToConceive && eleRef.state.isMobile &&
          <section className="slideTemp non_login_section_div feed_desktopview_hide" >
              <div className="non_login_div_child">
                  <div className="B18_21 non_login_dnya"> Dnyaneshwari Deshmukh </div>
                  <div className="B20_21 non_login_conce"> Trying to Conceive </div>

                  <div className="non_logign_circle_div" onClick={()=>{this.openPopup()}}> 
                     <a href="#">
                     <img src="../../../../images/07-Trying-to-concieve.jpg" alt="Trying to Conceive" title="Trying to Conceive"/>
                     </a>
                  </div>
              </div>
        </section>
        }
    </div>
    )
}
